import React from "react";
import { useNavigate } from "react-router-dom";
import MapImage from "../assets/Map.jpeg";
import "./Footer.css";

const Footer = () => {
  const navigate = useNavigate();

  const googleMapsUrl = "https://maps.app.goo.gl/kDiC2P2KpRCaJn8t8?g_st=aw";
  
  // Social media links
  const socialLinks = {
    facebook: "https://www.facebook.com/share/1Zd9it1bCW/",
    instagram: "https://www.instagram.com/servitecounseling?igsh=MXQybnJ1bzYycjR4cg==",
    linkedin: "https://www.linkedin.com/in/rosari-sahaya-rani-10302939a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    // youtube: "#" // Placeholder for YouTube link
  };

  // Function to handle link clicks with scroll to top
  const handleLinkClick = (path) => {
    navigate(path);
    // Scroll to top of the page
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <footer className="footer">
      {/* TOP TITLE */}
      <div className="footer-header">
        {/* HEART ICON */}
        <div className="footer-icon"></div>
        <h2>Servite Counselling Centre</h2>
        <p>Where healing begins with listening and understanding</p>
      </div>

      <div className="footer-grid">
        {/* DOCTOR DETAILS */}
        <div className="footer-col">
          <h4 className="footer-title">Our Counsellors</h4>
          <div className="doctor-card">
            <p className="doctor-name">Sr. Rosari Sahaya Rani</p>
            <span className="doctor-role">
              Licensed Counsellor & Clinical Psychotherapist
            </span>
          </div>
          <div className="doctor-card">
            <p className="doctor-name">Sr. Dr. Deepa</p>
            <span className="doctor-role">
              BHMS – Homoeopathic Physician
            </span>
          </div>
        </div>

        {/* CONTACT + TIMINGS */}
        <div className="footer-col">
          <h4 className="footer-title">Contact & Timings</h4>
          <p className="text-line">
            Servite Counselling Centre<br />
            Vattakarai, Near Holycross College<br />
            Nagercoil-629004, Tamil Nadu, India
          </p>
          <p className="text-line">
            <strong>Counselling Helpline:</strong><br />
            <a href="tel:+918148600633" className="phone-link">
              +91 8148 600 633
            </a>
          </p>
          <p className="text-line">
            <strong>Email:</strong><br />
            <a href="mailto:servitecounselling@gmail.com" className="phone-link">
              servitecounselingcentre@gmail.com
            </a>
          </p>
          <div className="timing-box">
            <p><strong>Morning Session</strong><br />9:30 AM – 12:00 PM</p>
            <p><strong>Evening Session</strong><br />4:00 PM – 7:00 PM</p>
          </div>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-col">
          <h4 className="footer-title">Quick Links</h4>
          <ul className="services-list">
            <li onClick={() => handleLinkClick("/")}>Home</li>
            <li onClick={() => handleLinkClick("/about")}>About</li>
            <li onClick={() => handleLinkClick("/services")}>Services</li>
            <li onClick={() => handleLinkClick("/programs")}>
              Programs & Workshop
            </li>
            <li onClick={() => handleLinkClick("/contact")}>Contact</li>
          </ul>
        </div>

        {/* MAP */}
        <div className="footer-col">
          <h4 className="footer-title">Find Us</h4>
          <a
            href={googleMapsUrl}
            target="_blank"
            rel="noreferrer"
            className="map-wrapper"
          >
            <img src={MapImage} alt="Servite Location Map" />
            <span className="map-overlay">View Map</span>
          </a>
          <p className="map-note">
            Click the map to open in Google Maps
          </p>
        </div>
      </div>

      {/* SOCIAL MEDIA SECTION - Added above the bottom bar */}
      <div className="social-section">
        <h4 className="social-title">Follow Us On</h4>
        <div className="social-icons">
          <a 
            href={socialLinks.facebook} 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-icon"
            aria-label="Facebook"
          >
            <i className="bi bi-facebook"></i>
          </a>
          <a 
            href={socialLinks.instagram} 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-icon"
            aria-label="Instagram"
          >
            <i className="bi bi-instagram"></i>
          </a>
          <a 
            href={socialLinks.linkedin} 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-icon"
            aria-label="LinkedIn"
          >
            <i className="bi bi-linkedin"></i>
          </a>
          
        </div>
        <p className="social-note">
          Stay updated with our latest programs and mental health tips
        </p><br></br>
        {/* BOTTOM BAR */}
      
        <p>© 2025 Servite Counselling Centre — All Rights Reserved</p>
        <p className="disclaimer">
          Confidential • Safe • Professional Counselling Support
        </p>
      </div>
      

      
    </footer>
  );
};

export default Footer;